import React, { useState } from "react";
import classNames from "classnames"
import styles from "../../styles/MobileHero.module.scss";
import { isMobile } from "react-device-detect";

const MobileHero = ({
  heroImage,
  heroTitle,
  heroSubText,
  hasButton,
  heroButton,
  alignItems,
  headlineImage,
  imageText,
  className,
  ...props
}) => {
  const [hover, setHover] = useState(false);

  const textStyle =
    alignItems === "left"
      ? {
          alignItems: "center",
          // alignItems: "flex-start",
          textAlign: "left",
          backgroundColor: "#111111",
        }
      : {
          alignItems: "center",
          textAlign: "center",
          backgroundColor: "#111111",
        };

  const buttonClick = () => {
    if (hasButton) {
      const link = heroButton.buttonLink;
      if (heroButton.isLinkExternal) {
        window.open(link, "_blank");
      } else {
        props.router.history.push(link);
      }
    }
  };

  const renderTextAndButton = (title, subtext) => {
    const ctaText = isMobile ? "Get Started" : heroButton?.buttonText;

    return (
      <div className={styles.titleWrapper} style={textStyle}>
        {title && <h1 className={styles.heroTitle}>{title}</h1>}
        {subtext && <div className={styles.heroSubtext}>{subtext}</div>}
        {props.children}
        {hasButton && (
          <button
            className={styles.heroButton}
            style={{
              backgroundColor: hover
                ? heroButton.hoverStyle.buttonColor
                : heroButton.buttonColor,
              borderColor: hover
                ? heroButton.hoverStyle.borderColor
                : heroButton.borderColor,
              color: hover ? heroButton.hoverStyle.textColor : null,
            }}
            onClick={buttonClick}
            onMouseEnter={() => {
              setHover(true);
            }}
            onMouseLeave={() => {
              setHover(false);
            }}
          >
            {ctaText}
          </button>
        )}
      </div>
    );
  };

  const renderTextAndButtonWithImage = (title, alt, subtext) => {
    const ctaText = isMobile ? "Get Started" : heroButton?.buttonText;

    return (
      <div className={styles.titleWrapper} style={textStyle}>
        <img src={title} alt={alt} className={styles.mobileTitleImage} />
        {subtext && <div className={styles.heroSubtext}>{subtext}</div>}
        {props.children}
        {hasButton && (
          <button
            className={styles.heroButton}
            style={{
              backgroundColor: hover
                ? heroButton.hoverStyle.buttonColor
                : heroButton.buttonColor,
              borderColor: hover
                ? heroButton.hoverStyle.borderColor
                : heroButton.borderColor,
              color: hover ? heroButton.hoverStyle.textColor : null,
            }}
            onClick={buttonClick}
            onMouseEnter={() => {
              setHover(true);
            }}
            onMouseLeave={() => {
              setHover(false);
            }}
          >
            {ctaText}
          </button>
        )}
      </div>
    );
  };

  return (
    <div className={classNames(styles.container, className)}>
      <img alt={heroImage.alt || heroTitle} src={heroImage.mobileUrl} />
      {heroTitle &&
        !headlineImage &&
        renderTextAndButton(heroTitle, heroSubText)}
      {headlineImage &&
        renderTextAndButtonWithImage(heroTitle, imageText, heroSubText)}
    </div>
  );
};

export default MobileHero;
